import { tr, localizedStatic } from "@/i18n/copy";
export const TEAM_ROLES = localizedStatic([
  ["artist", "Professionista"],
  ["front_desk", "Reception"],
  ["manager", "Agent Manager"],
  ["agent_marketing", "Agent Marketing"],
], [[0,1],[1,1],[2,1],[3,1]]);
